module.exports = __webpack_public_path__ + "img/2_05.00a53627.jpg";